import classdefs from './Entry.module.css';

const Entry = props => {
    return (
    <div>{props.entry} 
    {props.sentBy && <span className={classdefs.attrib}>&nbsp;&mdash;{props.sentBy}</span>}
    </div>
    );
}

export default Entry;
